<template>
  <div id="app">
    <Notification/>
    <Navbar/>
    <router-view/>
    <Footer>
    </Footer>
  </div>
</template>


<script>
import Notification from './components/Notification'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
export default {
  components: {
    Notification,
    Navbar,
    Footer
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Anton&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
@import "~bulma/sass/utilities/_all";
$primary: #82bc00;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
$dvoblack: #111900;
$dvogreen: #82bc00;
$dvogreen-invert: findColorInvert($dvogreen);
$dvodark: #1a1a1a;
$dvodark-invert: findColorInvert($dvodark);
$dvogrey: #222222;
$dvogrey-invert: findColorInvert($dvogrey);
$dvoalt: #1e1e1e;
$dvoalt-invert: findColorInvert($dvoalt);
$dvolightgrey: #3e3e3e;
$dvolightgrey-invert: findColorInvert($dvolightgrey);
$darktertiary: #282828;
$darktertiary-invert: findColorInvert($darktertiary);
$dvonotwhite: #d0cfce;
$dvonotwhite-invert: findColorInvert($dvonotwhite);
$dvonotalt: #414141;
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert),
    "dvogreen": ($dvogreen, $dvogreen-invert),
    "dvodark": ($dvodark, $dvodark-invert),
    "dvogrey": ($dvogrey, $dvogrey-invert),
    "dvoalt": ($dvoalt, $dvoalt-invert),
    "dvolightgrey": ($dvolightgrey, $dvolightgrey-invert),
    "dvonotwhite" : ($dvonotwhite, $dvonotwhite-invert)

);
// Links
$link: $dvogreen;
$link-invert: $dvogreen;
$link-focus-border: $dvogreen;

$card-background-color: $dvodark;
$card-color: $white;
$card-header-color: $white;

$background: $dvogrey;

$label-color: $white;

$table-color: $white;
$table-head-cell-color: $dvogreen;
$table-striped-row-even-background-color: $dvoalt;
$table-background-color: $dvodark;
$table-cell-border: 0px;

$input-background-color: $dvodark;
$input-border-color: $dvonotalt;
$input-hover-color: $dvoalt;
$input-color: $white;
$dropdown-content-background-color: $dvodark;

$navbar-background-color:$dvodark;
$navbar-item-color: #d0cfce;
$navbar-item-hover-background-color: #2e2e2e;
$navbar-dropdown-background-color: $dvodark;
$navbar-dropdown-border-top: 0px;
$navbar-dropdown-item-hover-color: $dvogreen;
$navbar-height: 4rem;

$input-placeholder-color: rgb(150, 145, 145);
$input-placeholder-opacity: 0.3;

$dropdown-content-background-color: $white;
$dropdown-item-hover-background-color: $light;

$datepicker-background-color: $dvodark;
$datepicker-item-color: $white;

// $sidebar-background: $dvodark;
// $sidebar-colors: $dvogrey;

$panel-tab-border-bottom: 0px ;

$loading-background: $dvogrey;

$footer-background-color: $black;
$footer-color: white;
// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

html{
  background-color: #222222;
}
.background{
  background-image: url("/bike_background.png");
  background-position: center;
  background-size: cover;
}
.full{
  min-height: 75vh;
}
.is-size-3{
  font-family:  'Anton', sans-serif;
}
</style>